
        <div class="k-contrast-ratio">
            <span class="k-contrast-ratio-text">{{contrastRatioMessage}}: {{formatedRatio}}</span>
            <span class="k-contrast-validation k-text-success" *ngIf="satisfiesAACondition">
                <span class="k-icon k-i-check"></span>
                <span class="k-icon k-i-check" *ngIf="satisfiesAAACondition"></span>
            </span>
            <span class="k-contrast-validation k-text-error" *ngIf="!satisfiesAACondition">
                <span class="k-icon k-i-close"></span>
            </span>
        </div>
        <div kendoContrastValidation
            type="AA"
            [ratio]="aaaRatio"
            [pass]="satisfiesAACondition">
        </div>
        <div kendoContrastValidation
            type="AAA"
            [ratio]="aaaRatio"
            [pass]="satisfiesAAACondition">
        </div>
    